/**
 * input兼容ie9 placeholder
 * @param 无
 * @author 王荣磊
 * @creatTime 2019/6/20
 */
import Vue from 'vue'
// 说明: v-ie-placeholder 挂载在input||textarea父级及以上,挂在本身不生效,父级下多个input,给每个input增加父级元素在进行挂载，element可直接挂载el-input,el-select上
Vue.directive('ie-placeholder', {
  inserted(el, binding) {
    const placeholder = binding.value // 自定义placeholder
    el.className = `${el.className} v-ie-placeholder` // 必须有空格 全局增加ie-placeholder样式
    const input = el.querySelector('input') || el.querySelector('textarea')
    input && bindBlaceholder(input, placeholder)
  },
})
function bindBlaceholder(element, placeholder) {
  if (!('placeholder' in document.createElement('input'))) {
    // 1. 原input
    element.addEventListener('focus', function () {
      this.nextSibling.style.display = 'none'
    })
    element.addEventListener('blur', function () {
      if (!this.value) {
        this.style.display = 'none'
        this.nextSibling.style.display = 'inline-block'
      }
    })

    // 2.副本input
    const cloneNode = element.cloneNode()
    if (cloneNode.tagName.toLowerCase() === 'textarea') {
      // textarea
      cloneNode.innerText = placeholder || cloneNode.getAttribute('placeholder')
    } else {
      // input 如果[type='password']类型，则转为text
      if ((cloneNode.getAttribute('type') || 'text').toLowerCase() === 'password') {
        cloneNode.setAttribute('type', 'text')
      }
      cloneNode.setAttribute('value', placeholder || cloneNode.getAttribute('placeholder'))
    }
    // 默认隐藏
    cloneNode.className += ' ie-placeholder' // 必须有空格 全局增加ie-placeholder样式
    cloneNode.style.display = 'none'
    cloneNode.style.color = '#C6CDD7' // input颜色

    // 3.插入副本
    element.insertAdjacentHTML('afterend', cloneNode.outerHTML)
    element.nextSibling.addEventListener('focus', function () {
      this.style.display = 'none'
      this.previousSibling.style.display = 'inline-block'
      this.previousSibling.focus()
    })
    if (!element.value) {
      element.style.display = 'none'
      element.nextSibling.style.display = 'inline-block'
    }
    const _this = element
    element.attachEvent('onpropertychange', (o) => {
      if (o.propertyName === 'value') {
        if (_this.value) {
          _this.style.display = 'inline-block'
          _this.nextSibling.style.display = 'none'
        } else if (_this.value === '') {
          _this.style.display = 'none'
          _this.nextSibling.style.display = 'inline-block'
          _this.blur()
        }
      }
    })
  }
}
